document.addEventListener('DOMContentLoaded', function () {
  const filterBar = document.querySelector('.collection-filters-bar');
  if (!filterBar) return;

  function normalize(value) {
    return String(value || '').trim().toLowerCase();
  }

  function getCards() {
    return document.querySelectorAll('.season-product-card');
  }

  function getGroups() {
    return Array.from(filterBar.querySelectorAll('.filter-segment[data-filter-group]')).filter(function (group) {
      return !group.hidden && window.getComputedStyle(group).display !== 'none';
    });
  }

  function getSelectedValue(group) {
    const activeButton = group.querySelector('.filter-segment__btn.is-active');
    return activeButton ? normalize(activeButton.dataset.value) : 'all';
  }

  function getCardTags(card) {
    return normalize(card.dataset.tags || '')
      .split(',')
      .map(function (tag) {
        return normalize(tag);
      })
      .filter(Boolean);
  }

  function valueMatches(tags, value) {
    const normalizedValue = normalize(value);

    if (normalizedValue === 'all') {
      return true;
    }

    return tags.includes(normalizedValue);
  }

  function cardMatches(card) {
    const tags = getCardTags(card);
    const groups = getGroups();

    return groups.every(function (group) {
      const value = getSelectedValue(group);
      return valueMatches(tags, value);
    });
  }

  function applyFilters() {
    const cards = getCards();
    if (!cards.length) return;

    cards.forEach(function (card) {
      const show = cardMatches(card);
      card.classList.toggle('is-hidden', !show);
    });

    if (window.scheduleRefreshCardThumbOrder) {
      window.scheduleRefreshCardThumbOrder(document);
    }
  }

  filterBar.addEventListener('click', function (event) {
    const button = event.target.closest('.filter-segment__btn');
    if (!button || !filterBar.contains(button)) return;

    const group = button.closest('.filter-segment');
    if (!group) return;

    group.querySelectorAll('.filter-segment__btn').forEach(function (btn) {
      btn.classList.remove('is-active');
    });

    button.classList.add('is-active');
    applyFilters();
  });

  const observer = new MutationObserver(function () {
    applyFilters();
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });

  applyFilters();
});